export default "__VITE_ASSET__B$C5hhhg__"